<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M4 6H20M6.5 4.5V7.5" stroke="#000" stroke-width="1.5"/>
  <path d="M4 12H20M12 10.5V13.5" stroke="#000" stroke-width="1.5"/>
  <path d="M4 18H20M16.5 16.5V19.5" stroke="#000" stroke-width="1.5"/>
</svg>
